<template>
  <ImageUpload
    v-model="cover"
    :disabled="isTournamentFieldDisabled('cover')"
    :label="$$t('Cover:', 'cover-bg-label')"
    :height="228"
    class="tournament-cover-input"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ImageUpload from '@/components/form/ImageUpload';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentCoverSetting',
  inject: ['$validator'],
  components: {
    ImageUpload,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    ...mapGetters([
      'currentTournament',
      'isTournamentFieldDisabled',
      'getGamePropById',
    ]),
    cover: {
      get() {
        return (
          this.$lodash.get(
            this.currentTournament,
            'images.cover.objectURL',
            ''
          ) ||
          this.$lodash.get(
            this.currentTournament,
            'images.cover.display_uri',
            ''
          ) ||
          this.$lodash.get(this.currentTournament, 'images.cover', '') ||
          this.getGamePropById(
            this.$lodash.get(this.currentTournament, 'info.game', ''),
            'cover'
          )
        );
      },
      set(val) {
        this.updateCurrentTournament({
          cover: val,
          component: 'images',
        });

        const portraitCover = this.$lodash.get(
          this.currentTournament,
          'images.portrait_cover',
          ''
        );
        if (!portraitCover && val) {
          this.updateCurrentTournament({
            portrait_cover: val,
            component: 'images',
          });
        }
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
<style lang="scss">
.tournament-cover-input {
  .embed-responsive {
    max-height: 208px;
  }
}
</style>
